module.exports = __webpack_public_path__ + "img/logo-Px-negativo.82d776c6.svg";